import { Link } from "react-router-dom";

interface Business {
  id: string;
  icon: string;
  title: string;
  description: string;
  heroBg: string;
  detailIntro: string;
  highlights: { label: string; value: string; unit: string }[];
}

interface BusinessHeroProps {
  business: Business;
}

export default function BusinessHero({ business }: BusinessHeroProps) {
  return (
    <section id="overview" className="relative pt-20">
      {/* Hero Banner */}
      <div className="relative h-[420px] overflow-hidden">
        <img
          src={business.heroBg}
          alt={business.title}
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/40 to-black/60"></div>

        {/* Hero Content */}
        <div className="absolute inset-0 flex items-center">
          <div className="max-w-7xl mx-auto px-6 lg:px-8 w-full">
            <div className="max-w-2xl">
              <div className="flex items-center gap-3 mb-4">
                <div className="w-12 h-12 bg-white/20 backdrop-blur-sm rounded-xl flex items-center justify-center">
                  <i className={`${business.icon} text-2xl text-white`}></i>
                </div>
                <span className="text-sm font-medium text-teal-300 tracking-wider uppercase">Core Business</span>
              </div>
              <h1 className="text-4xl lg:text-5xl font-bold text-white mb-4 leading-tight">
                {business.title}
              </h1>
              <p className="text-lg text-white/80 leading-relaxed">
                {business.description}
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Stats Bar */}
      <div className="max-w-7xl mx-auto px-6 lg:px-8 -mt-16 relative z-10">
        <div className="bg-white rounded-2xl shadow-xl p-8 grid grid-cols-2 lg:grid-cols-4 gap-8">
          {business.highlights.map((item, idx) => (
            <div key={idx} className="text-center">
              <div className="flex items-baseline justify-center gap-1">
                <span className="text-3xl lg:text-4xl font-bold text-teal-600">{item.value}</span>
                {item.unit && <span className="text-sm text-gray-500 font-medium">{item.unit}</span>}
              </div>
              <p className="text-sm text-gray-500 mt-1">{item.label}</p>
            </div>
          ))}
        </div>
      </div>

      {/* Intro Section */}
      <div className="max-w-7xl mx-auto px-6 lg:px-8 py-16">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="text-2xl font-bold text-gray-900 mb-6">业务概述</h2>
          <p className="text-base text-gray-600 leading-relaxed">{business.detailIntro}</p>
        </div>
      </div>
    </section>
  );
}
